import type { Point } from '../core/types';
import { bucketFillAt, panBy, pickColor, zoomStep } from '../state/actions';
import type { Tool } from './types';

export const bucketTool: Tool = {
  id: 'bucket',
  cursor: 'crosshair',
  hint: 'Click to fill the contiguous area with the foreground color',
  onPointerDown(event, ctx) {
    ctx.setStatus('Filling…');
    bucketFillAt(event.point);
    ctx.setStatus('Ready');
  },
};

export const eyedropperTool: Tool = (() => {
  let sampling = false;
  return {
    id: 'eyedropper',
    cursor: 'crosshair',
    hint: 'Click to sample a color; Alt while painting does the same',
    onPointerDown(event, ctx) {
      sampling = true;
      pickColor(event.point, ctx.options.eyedropperFromComposite);
    },
    onPointerMove(event, ctx) {
      if (!sampling) return;
      pickColor(event.point, ctx.options.eyedropperFromComposite);
    },
    onPointerUp() {
      sampling = false;
    },
    cancel() {
      sampling = false;
    },
  };
})();

export const handTool: Tool = (() => {
  let last: Point | null = null;
  return {
    id: 'hand',
    cursor: 'grab',
    hint: 'Drag to pan the canvas; holding Space does the same',
    onPointerDown(event) {
      last = event.screen;
    },
    onPointerMove(event) {
      if (!last) return;
      panBy(event.screen.x - last.x, event.screen.y - last.y);
      last = event.screen;
    },
    onPointerUp() {
      last = null;
    },
    cancel() {
      last = null;
    },
  };
})();

export const zoomTool: Tool = {
  id: 'zoom',
  cursor: 'zoom-in',
  hint: 'Click to zoom in, Alt+click to zoom out',
  onPointerDown(event) {
    zoomStep(event.alt ? -1 : 1, event.screen);
  },
};
